import { render } from "./reject-component.vue?vue&type=template&id=2a298b6a"
import script from "./reject-component.vue?vue&type=script&lang=js"
export * from "./reject-component.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__